import * as React from "react";
import { cn } from "@/lib/utils";

function Dialog({ open, onOpenChange, children }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-end justify-center p-4 sm:items-center">
      <button
        type="button"
        className="absolute inset-0 bg-black/70"
        aria-label="Close dialog"
        onClick={() => onOpenChange(false)}
      />
      {children}
    </div>
  );
}

function DialogContent({ className, children, onClose }) {
  return (
    <div
      className={cn(
        "relative z-[101] w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-xl border border-de-gold/30 bg-gradient-to-br from-[#0f2040] to-[#0D1B2A] p-6 shadow-2xl",
        className
      )}
    >
      {onClose && (
        <button
          type="button"
          className="absolute right-3 top-3 z-10 flex min-h-10 min-w-10 items-center justify-center rounded-xl border border-white/10 bg-black/20 text-de-muted backdrop-blur-sm transition-colors hover:border-de-gold/30 hover:text-de-gold"
          onClick={onClose}
          aria-label="Close"
        >
          ✕
        </button>
      )}
      {children}
    </div>
  );
}

function DialogHeader({ className, children }) {
  return <div className={cn("mb-4 space-y-1 pr-8", className)}>{children}</div>;
}

function DialogTitle({ className, children }) {
  return <h3 className={cn("text-lg font-bold text-de-gold", className)}>{children}</h3>;
}

function DialogDescription({ className, children }) {
  return <p className={cn("text-sm text-de-muted", className)}>{children}</p>;
}

function DialogFooter({ className, children }) {
  return (
    <div className={cn("mt-6 flex flex-col gap-2 sm:flex-row sm:justify-end", className)}>
      {children}
    </div>
  );
}

export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter };
